const words = ["Health", "Wealth", "Mindset", "Relationships", "Vitality", "Purpose"];

export const Marquee = () => {
  const row = [...words, ...words];
  return (
    <div className="relative border-y border-brand-line bg-brand-surface py-8 overflow-hidden">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-5xl md:text-7xl text-brand-text/90 px-10">
              {w}
            </span>
            <span className="text-brand-gold text-3xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
